import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "absolute inset-0" }
const _hoisted_2 = { class: "inline-block align-middle mr-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "×", -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["Toast px-6 py-4 border-0 rounded relative mb-4", _ctx.classes])
        }, [
          _createElementVNode("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("button", {
            class: "absolute bg-white rounded-full text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeAlert()))
          }, _hoisted_4)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}